export default class Context {
  constructor() {
    this.contextValue = "@context";
    this.edcPrefix = "edc";
    this.dcatPrefix = "dcat";
    this.dctPrefix = "dct";
    this.dpvPrefix = "dpv";
    this.admsPrefix = "adms";
    this.msPrefix = "ms";
    this.locPrefix = "loc";
    this.ianaPrefix = "iana";
    this.rdfPrefix = "rdf";
    this.xsdPrefix = "xsd";
    this.foafPrefix = "foaf";
    this.basePrefix = "@base";
    this.omtdPrefix = "omtd";
    this.skosPrefix = "skos";
    this.dcatlds = "dcatlds";

    this.edcNamespace = "https://w3id.org/edc/v0.0.1/ns/";
    this.dcatNamespace = "http://www.w3.org/ns/dcat#";
    this.dctNamespace = "http://purl.org/dc/terms/";
    this.admsNamespace = "http://www.w3.org/ns/adms#";
    this.msNamespace = "http://w3id.org/meta-share/meta-share/";
    this.locNamespace = "http://id.loc.gov/vocabulary/iso639-1/";
    this.ianaNamespace = "http://www.iana.org/assignments/media-types/application/";
    this.rdfNamespace = "http://www.w3.org/1999/02/22-rdf-syntax-ns#";
    this.xsdNamespace = "http://www.w3.org/2001/XMLSchema#";
    this.foafNamespace = "http://xmlns.com/foaf/0.1/";
    this.baseNamespace = "https://language-data-space.eu/entity/"; // "https://lds.eu/";
    this.omtdNamespace = "http://w3id.org/meta-share/omtd-share/";
    this.odrlNamespace = "http://www.w3.org/ns/odrl/2/";
    this.skosNamespace = "http://www.w3.org/2004/02/skos/core#";
    this.dpvNamespace = "https://w3id.org/dpv#";
    this.it6Namespace = "http://data.europa.eu/it6/";
    this.dcatldsNamespace = "http://w3id.org/lang-dcat-ap/";

    this.context = {
      [this.edcPrefix]: this.edcNamespace,
      [this.dcatPrefix]: this.dcatNamespace,
      [this.dctPrefix]: this.dctNamespace,
      [this.admsPrefix]: this.admsNamespace,
      [this.msPrefix]: this.msNamespace,
      [this.locPrefix]: this.locNamespace,
      [this.ianaPrefix]: this.ianaNamespace,
      [this.rdfPrefix]: this.rdfNamespace,
      [this.xsdPrefix]: this.xsdNamespace,
      [this.foafPrefix]: this.foafNamespace,
      [this.basePrefix]: this.baseNamespace,
      [this.omtdPrefix]: this.omtdNamespace,
      [this.skosPrefix]: this.skosNamespace,
      [this.dcatldsPrefix]: this.dcatldsNamespace,
    };
  }

  getContext() {
    return this.context;
  }

  getContextValue() {
    return this.contextValue;
  }

  getEdcPrefix() {
    return this.edcPrefix;
  }

  getDcatPrefix() {
    return this.dcatPrefix;
  }

  getDctPrefix() {
    return this.dctPrefix;
  }

  getAdmsPrefix() {
    return this.admsPrefix;
  }

  getMsPrefix() {
    return this.msPrefix;
  }

  getLocPrefix() {
    return this.locPrefix;
  }

  getIanaPrefix() {
    return this.ianaPrefix;
  }

  getRdfPrefix() {
    return this.rdfPrefix;
  }

  getXsdPrefix() {
    return this.xsdPrefix;
  }

  getFoafPrefix() {
    return this.foafPrefix;
  }

  getBasePrefix() {
    return this.basePrefix;
  }

  getOmtdPrefix() {
    return this.omtdPrefix;
  }

  getEdcNamespace() {
    return this.edcNamespace;
  }

  getDcatNamespace() {
    return this.dcatNamespace;
  }

  getDctNamespace() {
    return this.dctNamespace;
  }

  getAdmsNamespace() {
    return this.admsNamespace;
  }

  getMsNamespace() {
    return this.msNamespace;
  }

  getLocNamespace() {
    return this.locNamespace;
  }

  getIanaNamespace() {
    return this.ianaNamespace;
  }

  getRdfNamespace() {
    return this.rdfNamespace;
  }

  getXsdNamespace() {
    return this.xsdNamespace;
  }

  getFoafNamespace() {
    return this.foafNamespace;
  }

  getBaseNamespace() {
    return this.baseNamespace;
  }

  getOmtdNamespace() {
    return this.omtdNamespace;
  }

  getDcatLdsNamespace() {
    return this.dcatldsNamespace;
  }
}
